'use strict';

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
var consent = {
    getString: (urlAccept, textAccept, urlReject, textReject) => {
        //immediately return a calculate string value
        return `<div class="consent-drawer" id="consent-tracking" role="dialog">
            <div class="consent-text-wrapper"></div>
            <div class="consent-button-wrapper ml-auto">
                <button class="affirm btn btn-primary" data-url="${urlAccept}" autofocus>
                ${textAccept}
                </button>
            </div>
            <div class="consent-button-wrapper">
                <button class="decline btn btn-primary" data-url="${urlReject}" >
                ${textReject}
                </button>
            </div>
        </div>`;
    },
    showConsentDrawer: ($trackingElement) => {
        if ([undefined, null].indexOf($trackingElement) !== -1 || !$trackingElement.data('caonline') || $('#consent-tracking').length) {
            return;
        }

        var namespace = '.consenttrackingdrawer ',
            urlContent = $trackingElement.data('url'),
            urlAccept = $trackingElement.data('accept'),
            textAccept = $trackingElement.data('accepttext'),
            urlReject = $trackingElement.data('reject'),
            textReject = $trackingElement.data('rejecttext');

        var htmlString = consent.getString(urlAccept, textAccept, urlReject, textReject);

        $('body').append(htmlString);

        var $consentTracking = $('#consent-tracking');

        $.ajax({
            url: urlContent,
            type: 'get',
            dataType: 'html',
            context: $consentTracking,
            success: function (response) {
                this.find('.consent-text-wrapper').html(response);
            },
            error: function () {
                this.remove();
            }
        });

        $consentTracking.find('.consent-button-wrapper button').on('click' + namespace, (event) => {
            event.preventDefault();
            var url = $(event.target).data('url');
            var queryString = {
                csrf_token: $('.tracking-consent').data('token')
            };

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: queryString,
                context: $consentTracking,
                complete: function () {
                    this.remove();
                },
                error: function () {
                    this.remove();
                }
            });
        });
    },
    init: () => {
        var namespace = '.consenttracking ',
            $body = $('body'),
            $trackingConsent = $('.tracking-consent');

        if ($('.consented').length === 0 && $trackingConsent.hasClass('api-true')) {
            consent.showConsentDrawer($trackingConsent);
        }

        $trackingConsent.each((index, element) => {
            var $this = $(this);

            if ($this.hasClass('api-true')) {
                $this.on('click' + namespace, () => {
                    consent.showConsentDrawer($this);
                });
            }
        });

        $('.js-tracking-consent-show').on('click' + namespace, (e) => {
            e.preventDefault();
            consent.showConsentDrawer($trackingConsent);
        });
    }
};

module.exports = consent;
